import React, { forwardRef } from 'react';

const IcStatusCritical = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties,
    ref
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
      fill: "var(--negative-icon-default)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M10.505 6.495a.7.7 0 0 0-.99-.99L7.981 7.039 6.495 5.553a.7.7 0 0 0-.99.99l1.486 1.486-1.436 1.436a.7.7 0 0 0 .99.99l1.436-1.436 1.484 1.483a.7.7 0 1 0 .99-.99L8.971 8.03l1.534-1.534Z",
      fill: "var(--negative-icon-in-default)",
      fillRule: "evenodd"
    }
  )
));

export { IcStatusCritical };
//# sourceMappingURL=ic-status-critical.js.map
